/**
 * Get Aggregate Handler
 * 
 * CQRS Query Handler that delegates to AggregateQueryService.
 * Thin adapter layer for read operations.
 */

import { injectable, inject } from 'inversify';
import { DDD_SYMBOLS } from '../../../../infrastructure/di/DDD_SYMBOLS';
import { IQueryHandler } from '@swoft/core';
import { GetAggregateQuery, ListAggregatesQuery, AggregateDto } from '../queries/GetAggregateQuery';
import { AggregateQueryService } from '../services/AggregateQueryService';

@injectable()
export class GetAggregateHandler implements IQueryHandler<GetAggregateQuery, AggregateDto | null> {
  constructor(
    @inject(DDD_SYMBOLS.AggregateQueryService) private aggregateQueryService: AggregateQueryService
  ) {}

  async handle(query: GetAggregateQuery): Promise<AggregateDto | null> {
    return await this.aggregateQueryService.getAggregate(query.aggregateId);
  }
}

@injectable()
export class ListAggregatesHandler implements IQueryHandler<ListAggregatesQuery, AggregateDto[]> {
  constructor(
    @inject(DDD_SYMBOLS.AggregateQueryService) private aggregateQueryService: AggregateQueryService
  ) {}

  async handle(query: ListAggregatesQuery): Promise<AggregateDto[]> {
    return await this.aggregateQueryService.listAggregates({
      boundedContextId: query.boundedContextId,
      domainId: query.domainId,
      includeComplexityAnalysis: query.includeComplexityAnalysis
    });
  }
}